import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const container = css({
  padding: "15px",
  height: "100%",
});
export const list = (theme: ExactTheme) =>
  css({
    padding: "15px",
    background: "white",
    borderRadius: theme.borderRadiusV2.primary,
    height: "100%",
  });
